import React from "react";
import s from "./style.module.scss";
import { INavItem } from "./types";
import { Link } from "react-router-dom";
import Arrow from "./icons/Arrow";

const Item: React.FC<INavItem> = ({ href, label, bonuses, updates }) => {
  return (
    <li className={s.item}>
      <Link to={href} className={s.link} />
      <span>{label}</span>

      <div className={s.left}>
        {bonuses && <div className={s.bonuses}>+{bonuses} бонусов</div>}
        {Number(updates) > 0 && <div className={s.updates}>{updates}</div>}

        <Arrow />
      </div>
    </li>
  );
};

export default Item;
